import { component } from 'picoapp';

export default component((node) => {
  const form = node.querySelector('form');
  const firstName = node.querySelector("input[name='$first_name']");
  const email = node.querySelector("input[name='$email']");
  const birthday = node.querySelector("input[name='Birthday']");
  const successText = node.querySelector('[data-success]');
  const errorText = node.querySelector('[data-errors]');

  const submitHandler = async (event) => {
    event.preventDefault();

    if (firstName.value === '' || email.value === '' || birthday.value === '') {
      errorText.hidden = false;
      successText.hidden = true;
    } else {
      successText.hidden = false;
      errorText.hidden = true;

      const formData = new FormData(form);
      await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'post',
        body: formData,
      });
    }
  };

  form.addEventListener('submit', submitHandler);
});
